import OfferStatsCard from './OfferStatsCard';
import { NumberField } from 'react-admin';
import { useListContext, useTranslate } from 'ra-core';
import { Report } from './types';

function StatsCards() {
  const { data = [] } = useListContext<Report>();
  const t = useTranslate();

  const totalImpressions =
    data.reduce((sum, report) => sum + (report.impressions || 0), 0) ?? 0;
  const totalClicks =
    data.reduce((sum, report) => sum + (report.clicks || 0), 0) ?? 0;
  const totalActions =
    data.reduce((sum, report) => sum + (report.actions || 0), 0) ?? 0;

  return (
    <div className="grid grid-cols-[repeat(auto-fit,minmax(180px,200px))] gap-3">
      <OfferStatsCard label={t('common.text.impressions')}>
        <NumberField
          record={{ impressions: totalImpressions }}
          source="impressions"
          variant="h6"
          color="textSecondary"
        />
      </OfferStatsCard>
      <OfferStatsCard label={t('common.text.clicks')}>
        <NumberField
          record={{ clicks: totalClicks }}
          source="clicks"
          variant="h6"
          color="textSecondary"
        />
      </OfferStatsCard>
      {Boolean(totalActions) && (
        <OfferStatsCard label={t('common.text.actions')}>
          <NumberField
            record={{ actions: totalActions }}
            source="actions"
            variant="h6"
            color="textSecondary"
          />
        </OfferStatsCard>
      )}
    </div>
  );
}

export default StatsCards;
